
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import "../style/App.css";
import "../style/Home.css";
import "../style/ReactBootstrapOverride.css";

// className="gradient-aboutus"

const AboutUsOurPurpose = () => {

    return (
        <Container fluid >

            <Row>
                <Col md={{ span: 9, offset: 4 }}>
                    <h1>
                        OUR PURPOSE
                    </h1>
                </Col>
            </Row>
            
            <Row className="pl-5 ml-5">
                <Row>
                    <Col  md={{ span: 9, offset: 3 }} style={ 
                                                    { background: "linear-gradient(to top right, #e30a13, #e30a13, #e30a13, #e30a13, #f18286)"  }}>
                    <p className="col-white px-5 mx-5">
                    To play an important part in surgical education, enhancing efficiency, fostering collaboration and by levelling the field empowering all trainees to have confidence in surgical skills building.
                    </p>
                    </Col>
                </Row>
            </Row>
        </Container>
    );
}

export default AboutUsOurPurpose;